// extracted by mini-css-extract-plugin
export default {"price":"_1tJed","increased":"_3Eo3g","decreased":"_emAW"};